import { useNavigate } from "react-router-dom";
import { api } from "../../api/client";
import { setSession } from "../../api/http";
import { Button, Icon, PageHeader, StatePanel } from "../../components/ui";
import { t } from "../../i18n";
import { useAppStore } from "../../state/appStore";

export function ProfilePage() {
  const navigate = useNavigate();
  const { authenticated, setAuthenticated, clear } = useAppStore();
  if (!authenticated)
    return (
      <div className="page">
        <PageHeader eyebrow={t.profile.eyebrow} title={t.profile.title} />
        <StatePanel
          icon="◉"
          title={t.profile.guestTitle}
          body={t.profile.guestBody}
          action={
            <Button onClick={() => navigate("/auth")}>
              {t.profile.signIn}
            </Button>
          }
        />
      </div>
    );
  async function logout() {
    await setSession(null);
    setAuthenticated(false);
    navigate("/");
  }
  async function remove() {
    if (!confirm(t.profile.deleteConfirm)) return;
    await api.deleteAccount();
    clear();
    navigate("/");
  }
  return (
    <div className="page">
      <PageHeader
        eyebrow={t.profile.eyebrow}
        title={t.profile.title}
        action={
          <button
            className="icon-button notification-button"
            onClick={() => navigate("/notifications")}
            aria-label={t.profile.notifications}
          >
            <Icon name="bell" />
          </button>
        }
      />
      <div className="profile-card">
        <div className="avatar">MM</div>
        <div>
          <h2>Mo</h2>
          <p>+961 71 234 567 · Verified</p>
        </div>
      </div>
      <Settings
        title={t.profile.account}
        rows={[
          [t.profile.personal, "›"],
          [t.profile.whish, `${t.profile.none} ›`],
          [t.profile.sessions, `${t.profile.thisDevice} ›`],
        ]}
      />
      <Settings
        title={t.profile.preferences}
        rows={[
          [t.profile.notifications, `${t.profile.pushOn} ›`],
          [t.profile.privacy, "›"],
          [t.profile.language, `${t.profile.english} ›`],
        ]}
      />
      <div className="notice">
        <strong>{t.profile.paymentPrivacy}</strong>
        <p>{t.profile.paymentPrivacyBody}</p>
      </div>
      <Button variant="secondary" onClick={() => void logout()}>
        {t.profile.logout}
      </Button>
      <Button variant="danger" onClick={() => void remove()}>
        {t.profile.delete}
      </Button>
    </div>
  );
}
function Settings({ title, rows }: { title: string; rows: string[][] }) {
  return (
    <section className="settings">
      <h2>{title}</h2>
      {rows.map((row) => (
        <button key={row[0]}>
          <span>{row[0]}</span>
          <span>{row[1]}</span>
        </button>
      ))}
    </section>
  );
}
